import { z } from 'zod';

export type SuggestReportPayload = {
  user_query: string;
  filters: { queues: string[] };
  current?: unknown;
  type?: 'sql' | 'mbql';
};

export const suggestReport = (payload: SuggestReportPayload) => {
  return {
    endpoint: `/internal/metabase/suggest_report`,
    method: 'POST',
    responseSchema: z.unknown(),
    payload,
    payloadSchema: z.unknown(),
  } as const;
};
